import { render, staticRenderFns } from "./TransationDetail.vue?vue&type=template&id=9f8a124e&"
import script from "./TransationDetail.vue?vue&type=script&lang=js&"
export * from "./TransationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports